import type { NextPage } from 'next'
import React from 'react'

import { withAuthenGuard } from '@lib/hoc/withAuthenGuard'
import { MyProfilePage } from '@features/profile/pages/MyProfilePage'
import { AppLayout } from '@components/layouts/AppLayout'
import { maintenanceHandler } from '@lib/maintenanceHandler'

const MyProfile: NextPage = () => {
  return (
    <AppLayout>
      <MyProfilePage />
    </AppLayout>
  )
}

export const getServerSideProps = async () => {
  return maintenanceHandler()
}

export default withAuthenGuard(MyProfile)
